import moment from 'moment';

export default {
  methods: {
    formatDate(date, formatStr = 'MM-DD-YYYY') {
      const mDate = moment(date);
      return mDate.isValid() ? mDate.format(formatStr) : '';
    }
  }
};